import React from "react";
import { string, object } from "prop-types";
import assetify from "@quintype/framework/assetify";

import * as image from "../../../../assets/images/FPJ_logo.jpg";
import * as image2 from "../../../../assets/images/rectangle_placeholder.png";
import PhotoIcon from "../icons/photo";

import "./placeholder-image.m.css";

const getImage = aspectRatio => {
  switch (aspectRatio) {
    case "267x332":
      return image2;
    default:
      return image;
  }
};

const PlaceholderImage = ({ className = "", aspectRatio = "", story }) => (
  <div className={className} styleName="wrapper">
    <img srcSet={`${assetify(getImage(aspectRatio))}`} src={assetify(getImage(aspectRatio))} alt="placeholder" />
    {story["story-template"] === "photo" && (
      <div styleName="photo-icon">
        <PhotoIcon />
      </div>
    )}
  </div>
);

PlaceholderImage.propTypes = {
  className: string,
  aspectRatio: string,
  story: object
};

export default PlaceholderImage;
